export const LOAD_ALL_TAXES = 'LOAD_ALL_TAXES'
export const LOAD_TAXES = 'LOAD_TAXES'
export const LOAD_TAX_TYPES = 'LOAD_TAX_TYPES'
export const ADD_TAX = "ADD_TAX"
export const UPDATE_TAX = 'UPDATE_TAX'
export const DELETE_TAX = 'DELETE_TAX'
